<template>
  <div class="video-container">

    <video id="myVideo" ref="myVideo" loop muted data-autoplay playsinline>
      <source src="/cg2.mp4" type="video/mp4">
    </video>

    <div class="intro">
      <div>
        <h1 :class="{'fadeInDown': sectionsIndex == 0}">
          <div class="logo-container">
            <img src="../../assets/images/logo_white.png" alt="">
            <span>识加科技</span>
          </div>
          <span>水产养殖行业的创新先锋</span>
        </h1>
        <!-- <p :class="{'fadeInUp': sectionsIndex==0}">SEE THE FUTURE WITH AI</p> -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['sectionsIndex'],
  data() {
    return {}
  },
  mounted() {
  },

}
</script>

<style lang="scss" scoped>


</style>
